import IwTracking from '../tracking/IwTracking';

export function redirectToURL(url) {
    const isMyAccountURL = url.split('/').includes('my_account');
    if (isMyAccountURL) IwTracking.trackRedirectToAccountPages();

    if (typeof window !== 'undefined') {
        window.location.href = url;
    }
}
